import React from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from "../../Context/AppContext";
import HeaderAdmin from "../../Components/HeaderAdmin";
import Booking from "../../Components/Reservas/Calendar";
import styled from "styled-components";

const ContainerPage=styled.div`
display:grid;
grid-template-columns:1fr;
grid-template-rows: 1fr;
`;

const ContainerList=styled.div`
display:grid;
grid-template-columns: 1fr ;
grid-template-rows: 1fr;`;

const Reservas = () => 
{
    const {user}=React.useContext(UserContext);
    if(Object.keys(user).length === 0 && user.constructor === Object)
    {
      return <Redirect to="/admin"/>
    }

    return <>
        <ContainerList>
            <HeaderAdmin title={"Reservas"}/>
            <Booking/>
        </ContainerList>
    </>
}

export default Reservas
